import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import ContactUs from "../components/ContactUs";

const Contacts = () => {
  return (
    <>
      <Breadcrumb title="About Us" />
      <ContactUs />
    </>
  );
};

export default Contacts;
